<template>
  <div class="swip-wrap o-h">
    <div class="my-swipe" :id="myId">
      <div class='swipe-wrap p-r o-h'>
        <div class="swipe-list p-r f-l" v-for="(item,index) in info.picList" :key='index'>
          <img :src="item.url" alt="">
        </div>
      </div>
    </div>
    <a href="javascript:;" v-if="info.bot" class="swipe-btn-prev d-b p-a" @click="prev" :style="{background:'url('+info.botBtn.prev+') center center no-repeat;background-size: cover;'}"></a>
    <a href="javascript:;" v-if="info.bot" class="swipe-btn-next d-b p-a" @click="next" :style="{background:'url('+info.botBtn.next+') center center no-repeat;background-size: cover;'}"></a>
    <div class="dot p-a" v-if="info.dot">
      <a href="javascript:;" @click="slide(index)" :class="[index==oindex ? 'dot-active':'',' dot-span d-i-b']" v-for="(item,index) in info.picList" :key='index'></a>
    </div>
  </div>
</template>

<script>
  export default {
    head: {
      script: [{
        src: 'https://food.efuntw.com/js/jquery.min.js'
      }, {
        src: "https://reskr-download.vsplay.com/res_kr/common/js/swipe.js",
      }]
    },
    props: ["id", "info"],
    data() {
      return {
        oindex: 0
      }
    },
    computed: {
      myId() {
        return "slide" + this.id;
      }
    },
    mounted() {
      const _this = this;
      this.$nextTick(() => {
        let elem = document.getElementById("slide" + this.id);
        window["mySwipe" + this.id] = Swipe(elem, {
          startSlide: 0,
          speed: 400,
          auto: 3000,
          continuous: true,
          disableScroll: false,
          stopPropagation: false,
          callback: function(index, elem) {
            _this.oindex = index;
          },
          transitionEnd: function(index, elem) {}
        });
      });
    },
    methods: {
      prev() {
        window["mySwipe" + this.id].prev();
      },
      next() {
        window["mySwipe" + this.id].next();
      },
      slide(_i) {
        this.oindex = _i;
        window["mySwipe" + this.id].slide(_i)
      }
    }
  };
</script>




// WEBPACK FOOTER //
// client/smsgz/components/common/swipe/index.vue